/* custom-order-qty-grid.js — Multi-variant size grid for custom order products
   Handles S-XL / 2XL / 3XL tier pricing with separate cart line items.
   Gallery hiding + variant picker hiding are done in color_field inline CSS. */
(function() {
  /* Hide Shop Pay / dynamic checkout on custom-order products */
  var spCss = document.createElement("style");
  spCss.textContent = ".shopify-payment-button,.dynamic-checkout__content,[data-shopify=\"dynamic-checkout-cart\"]{display:none !important}";
  document.head.appendChild(spCss);

  var qtyLabel = document.querySelector('[data-min-qty]');
  var mq = qtyLabel ? parseInt(qtyLabel.getAttribute('data-min-qty')) : 24;

  var ins = document.querySelectorAll('.sz-inp');
  if (!ins.length) return;

  var tot = document.getElementById('sz-tot');
  var err = document.getElementById('sz-err');
  var forms = document.querySelectorAll("form[action*='/cart/add']");

  /* --- Read variant data from embedded JSON script tag --- */
  var variantEl = document.getElementById('variant-data');
  var variantMap = {};
  try {
    variantMap = JSON.parse(variantEl.textContent);
  } catch(e) {}
  /* variantMap looks like: {"S-XL":"123","2XL":"456","3XL":"789","4XL":"111","5XL":"222"} */

  /* Map each size input to its variant tier */
  var sizeTiers = {
    'YXS': 'Youth', 'YS': 'Youth', 'YM': 'Youth', 'YL': 'Youth', 'YXL': 'Youth',
    'S': 'S-XL', 'M': 'S-XL', 'L': 'S-XL', 'XL': 'S-XL',
    '2XL': '2XL', '3XL': '3XL', '4XL': '4XL', '5XL': '5XL', '6XL': '6XL'
  };

  /* Create hidden quantity input in each form */
  forms.forEach(function(f) {
    if (!f.querySelector("input[name='quantity']")) {
      var hi = document.createElement('input');
      hi.type = 'hidden';
      hi.name = 'quantity';
      hi.value = '1';
      f.appendChild(hi);
    }
  });

  /* Save original fetch before override */
  var origFetch = window.fetch;


  /* --- Artwork: REQUIRED and actually uploaded [daniel, 2026-09-29] ---
     The template's <input type=file name="properties[Logo File]"> was never sent:
     addToCart posts JSON to /cart/add.js, so the file was dropped (#1030 came in with
     no art). Now the file(s) go to Convex storage and the download link rides on each
     cart line as the "Artwork" property, which shows on the Shopify order. */
  var CONVEX_MUT = 'https://adept-dragon-625.convex.cloud/api/mutation';
  var artInput = document.querySelector("input[type='file'][name*='Logo File'], input[type='file'][name*='properties']");
  var artUrls = null;
  if (artInput) {
    artInput.multiple = true;
    artInput.removeAttribute('name'); /* never let the form try to post it natively */
    var lab = artInput.parentNode.querySelector('label');
    if (lab) lab.textContent = 'Upload Your Artwork *';
    var hint = artInput.parentNode.querySelector('p');
    if (hint) hint.textContent = "Required. PNG, PDF, AI, EPS, or SVG preferred. A phone photo or sketch is fine, we'll send a proof before printing.";
    var artErr = document.createElement('p');
    artErr.style.cssText = 'display:none;color:#c00;font-size:13px;font-weight:700;margin:4px 0 0';
    artErr.textContent = '\u26a0\ufe0f Please upload your artwork to continue';
    artInput.parentNode.appendChild(artErr);
    artInput.addEventListener('change', function() { artUrls = null; if (artInput.files.length) artErr.style.display = 'none'; });
  }
  function artMissing() {
    if (!artInput || artInput.files.length) return false;
    artErr.style.display = 'block';
    artInput.parentNode.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return true;
  }
  function convexMut(path, args) {
    return origFetch(CONVEX_MUT, { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ path: path, args: args, format: 'json' }) })
      .then(function(r) { return r.json(); })
      .then(function(d) { if (d.status !== 'success') throw new Error(path + ' failed'); return d.value; });
  }
  function uploadArt() {
    if (!artInput || !artInput.files.length) return Promise.resolve([]);
    if (artUrls) return Promise.resolve(artUrls);
    var files = Array.prototype.slice.call(artInput.files);
    return Promise.all(files.map(function(f) {
      if (f.size > 50 * 1024 * 1024) throw new Error('File over 50 MB: ' + f.name);
      return convexMut('quotes:generateUploadUrl', {})
        .then(function(u) { return origFetch(u, { method: 'POST', headers: { 'Content-Type': f.type || 'application/octet-stream' }, body: f }); })
        .then(function(r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
        .then(function(j) { return convexMut('quotes:publicUrlForStorageId', { storageId: j.storageId }); })
        .then(function(url) { return { name: f.name, url: url }; });
    })).then(function(list) { artUrls = list; return list; });
  }

  /* --- Color validation --- */
  function checkColor() {
    var colorInput = document.getElementById('cs-val');
    if (!colorInput || !colorInput.value) {
      var cerr = document.getElementById('cs-color-err');
      if (!cerr) {
        cerr = document.createElement('p');
        cerr.id = 'cs-color-err';
        cerr.style.cssText = 'color:#c00;font-size:13px;margin:4px 0 0';
        var sel = document.getElementById('cs-sel');
        if (sel) sel.parentNode.insertBefore(cerr, sel.nextSibling);
      }
      cerr.textContent = '⚠️ Please select a color';
      cerr.style.display = 'block';
      var wrap = document.getElementById('cs-wrap');
      if (wrap) wrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return false;
    }
    var cerr = document.getElementById('cs-color-err');
    if (cerr) cerr.style.display = 'none';
    return true;
  }

  function getTotal() {
    var s = 0;
    ins.forEach(function(i) { s += parseInt(i.value) || 0; });
    return s;
  }

  /* --- Quantity-break support (only active when variant titles contain " / ") --- */
  var breakQty = 0, breakLow = '', breakHigh = '';
  Object.keys(variantMap).forEach(function(k) {
    var m = k.match(/ \/ (\d+)\+$/);
    if (m) { breakQty = parseInt(m[1]); breakHigh = m[1] + '+'; breakLow = '1-' + (breakQty - 1); }
  });
  function qtyTierVariant(tier) {
    if (!breakQty) return null;
    var label = getTotal() >= breakQty ? breakHigh : breakLow;
    return variantMap[tier + ' / ' + label] || null;
  }
  function updateTotal() {
    var s = getTotal();
    if (tot) tot.textContent = s;
    if (err) err.style.display = (s > 0 && s < mq) ? 'block' : 'none';
  }

  ins.forEach(function(i) {
    i.addEventListener('input', updateTotal);
    i.addEventListener('change', updateTotal);
  });

  /* --- Build cart items from size inputs --- */
  function buildCartItems() {
    var colorInput = document.getElementById('cs-val');
    var color = colorInput ? colorInput.value : '';

    /* Group quantities by variant tier */
    var tierQty = {};
    var tierSizes = {};
    ins.forEach(function(inp) {
      var q = parseInt(inp.value) || 0;
      if (q <= 0) return;
      /* Extract size from name like "properties[S]" or "properties[2XL]" */
      var m = inp.name.match(/\[([^\]]+)\]/);
      if (!m) return;
      var size = m[1];
      var tier = sizeTiers[size] || 'S-XL';
      tierQty[tier] = (tierQty[tier] || 0) + q;
      if (!tierSizes[tier]) tierSizes[tier] = [];
      tierSizes[tier].push(size + ':' + q);
    });

    var items = [];
    for (var tier in tierQty) {
      /* Quantity-break products (variants titled "S-XL / 1-6", "S-XL / 7+") */
      var vid = qtyTierVariant(tier) || variantMap[tier];
      if (!vid) continue;
      var props = { 'Color': color };
      /* Add size breakdown as property */
      if (tierSizes[tier]) {
        props['Sizes'] = tierSizes[tier].join(', ');
      }
      items.push({
        id: parseInt(vid),
        quantity: tierQty[tier],
        properties: props
      });
    }
    return items;
  }

  /* --- Multi-variant add to cart --- */
  function addToCart(callback) {
    var items = buildCartItems();
    if (!items.length) return;
    var btn0 = document.querySelector("button[name='add'], button.product-form__submit");
    var btnHtml = btn0 ? btn0.innerHTML : '';
    if (btn0) { btn0.disabled = true; btn0.innerHTML = 'Uploading artwork...'; }

    uploadArt().then(function(art) {
      items.forEach(function(it) {
        art.forEach(function(a, i) { it.properties[art.length > 1 ? 'Artwork ' + (i + 1) : 'Artwork'] = a.url; });
      });
      return origFetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
      });
    })
    .then(function(r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); })
    .then(function(data) {
      /* Show success and redirect to cart */
      var btn = document.querySelector("button[name='add'], button.product-form__submit");
      if (btn) {
        btn.innerHTML = '✓ Added to Cart!';
        btn.disabled = true;
      }
      if (callback) callback(null, data);
      window.location.href = '/cart';
    })
    .catch(function(e) {
      console.error('Cart add failed:', e);
      if (btn0) { btn0.disabled = false; btn0.innerHTML = btnHtml; }
      alert('Your artwork did not upload. Please try again, or call (714) 766-4601.');
      if (callback) callback(e);
    });
  }

  /* --- Intercept add-to-cart button clicks --- */
  var buttons = document.querySelectorAll("button[name='add'], button.product-form__submit");
  buttons.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      if (!checkColor() || artMissing()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      var s = getTotal();
      if (s < mq) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (err) {
          err.style.display = 'block';
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      /* Prevent Dawn's default handler */
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart();
    }, true);
  });

  /* --- Intercept form submit --- */
  forms.forEach(function(f) {
    f.addEventListener('submit', function(e) {
      if (!checkColor() || artMissing()) {
        e.preventDefault();
        e.stopImmediatePropagation();
        return false;
      }
      var s = getTotal();
      if (s < mq) {
        e.preventDefault();
        e.stopImmediatePropagation();
        if (err) {
          err.style.display = 'block';
          err.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return false;
      }
      e.preventDefault();
      e.stopImmediatePropagation();
      addToCart();
    }, true);
  });

  /* --- Intercept Dawn's fetch to /cart/add --- */
  window.fetch = function() {
    var url = arguments[0];
    if (typeof url === 'string' && url.indexOf('/cart/add') !== -1) {
      /* Only block if we have size inputs (multi-variant product) */
      if (ins.length > 0) {
        var s = getTotal();
        if (s < mq) {
          if (err) {
            err.style.display = 'block';
            err.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
          return Promise.reject(new Error('Minimum quantity not met'));
        }
        /* Don't let Dawn's default cart add through — we handle it ourselves */
        return Promise.resolve(new Response(JSON.stringify({items:[]}), {status:200}));
      }
    }
    return origFetch.apply(this, arguments);
  };

  updateTotal();
})();
